<template>
  <div>
    <div class="product-add">
      <el-row>
        <el-col :span="12">
          <!--form表单-->
          <el-form size="small" label-width="150px">
            <div class="common-form">服务费扣款费率</div>
            <el-form-item label="服务费扣款费率">
              <el-switch v-model="obj.serviceIsOpen" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="扣除比例">
              <el-input v-model="obj.serviceCharge" placeholder="值(百分比)" class="max-w460"></el-input>%
            </el-form-item>
            <div class="common-form">提现手续费</div>
            <el-form-item label="提现手续费">
              <el-switch v-model="obj.handlingIsOpen" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="扣除比例">
              <el-input v-model="obj.handlingCharge" placeholder="值(百分比)" class="max-w460"></el-input>%
            </el-form-item>
            <div class="common-form">储值扣款费率</div>
            <el-form-item label="储值扣款费率">
              <el-switch v-model="obj.storedIsOpen" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="扣除比例">
              <el-input v-model="obj.storedCharge" placeholder="值(百分比)" class="max-w460"></el-input>%
            </el-form-item>
            <div class="common-form">会员优惠</div>
            <el-form-item label="会员优惠">
              <el-switch v-model="obj.vipIsOpen" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item label="折扣比例">
              <el-input v-model="obj.vipCharge" placeholder="值" class="max-w460"></el-input>%
            </el-form-item>
            <div class="common-form">分成模式</div>
            <el-form-item label="分成模式">
              <el-switch v-model="obj.type" active-color="#13ce66" inactive-color="#ff4949" active-text="平台扣除" inactive-text="技师扣除" active-value="12" inactive-value="1">
              </el-switch>
            </el-form-item>

            <!-- <div class="common-form">技师完成订单时打卡</div>
            <el-form-item label="技师完成订单时打卡">
              <el-switch v-model="obj.clockInIsOpen" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <div class="common-form">用户完成订单签名</div>
            <el-form-item label="用户完成订单签名">
              <el-switch v-model="obj.userSign" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
            <div class="common-form">技师到达服务地点打卡</div>
            <el-form-item label="技师到达服务地点打卡">
              <el-switch v-model="obj.isArrive" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item> -->

          </el-form>
        </el-col>
        <el-col :span="12">
          <div class="" style="">
            <!-- font-size:16px; -->
            <div class="common-form">举例说明</div>
            <el-alert type="success" title="比例介绍与举例" effect="dark" :closable='false' description="订单总价580元 其中包含80元车费，项目金额为500元，用户使用50元优惠券">
            </el-alert>
            <el-row>
              <el-col :span="6" class="col_item">
                <div class="">会员优惠：0.95%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div class=" ">技师比例：70%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div class=" ">商户比例：15%</div>
              </el-col>
            </el-row>
            <!-- 第二行 -->
            <el-row>
              <el-col :span="6" class="col_item">
                <div>平台比例：100 - (技师 + 商户)</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div class=" bg-purple-light"> 储值扣款：1%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div>服务费：1%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div>提现手续费：1%</div>
              </el-col>
            </el-row>
            <!-- 第三行 -->
            <el-row>
              <el-col :span="6" class="col_item">
                <div> 技师一级佣金：5% </div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div class=" bg-purple-light"> 技师二级佣金：2%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div> 用户一级佣金：5%</div>
              </el-col>
              <el-col :span="6" class="col_item">
                <div> 用户二级佣金：2%</div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  会员优惠金额：580 * 0.95% = 5.51元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>会员优惠金额所有人分担</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  实际支付金额：580 - 50 - 5.51= 524.49元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>实际支付金额=订单总价 - 优惠券 - 会员优惠金额</span>
                </div>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  参与分成金额：524.49 - 80 = 444.49 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>参与分成金额=实际支付金额 - 车费</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  技师金额：444.49 * 70% = 311.14 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>技师金额 = 参与分成金额 * 技师比例</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  商户金额：444.49 * 15% = 66.67 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 商户金额 = 实际支付金额 * 商户比例 </span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  平台金额：444.49 - (311.14 + 66.67) = 66.68 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 平台金额 = 实际支付金额 - (技师金额 + 商户金额) </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  储值扣款：311.14 * 1% = 3.11 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 储值扣款 = 技师金额 * 储值扣款比例 </span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  服务费扣款：311.14 * 1% = 3.11 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 服务费扣款 = 技师金额 * 服务费比例 </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  提现手续费扣款：311.14 * 1% = 3.11 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 提现手续费扣款 = 技师金额 * 提现手续费比例 </span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  技师所得金额：311.14 - (3.11 + 3.11 + 3.11)= 301.81 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 技师所得金额 = 技师所得金额 - (储值扣款 + 服务费 + 提现手续费) </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  技师一级佣金：311.14 * 5% = 15.57 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 技师一级佣金 = 技师金额 * 技师一级佣金比例 </span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  技师二级佣金：311.14 * 2% = 6.22 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>技师二级佣金 = 技师金额 * 技师二级佣金比例 </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="num_case">
                  用户一级佣金：311.14 * 5% = 15.57 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span> 用户一级佣金 = 技师金额 * 用户一级佣金比例 </span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="num_case">
                  用户二级佣金：311.14 * 2% = 6.22 元
                </div>
                <div class="num_case co_case">
                  <span>注意：</span>
                  <span>用户二级佣金 = 技师金额 * 用户二级佣金比例 </span>
                </div>
              </el-col>
            </el-row>

            <div class="num_case">
              平台所得金额：66.68 + (3.11 + 3.11 + 3.11) = 76.01 元
            </div>
            <div class="num_case">
              <span class="co_case">注意：</span>
              <span class="co_case"> 平台所得金额 = 平台所得金额 + 储值扣款 + 服务费 + 提现手续费 ,分为两种情况 技师扣除 和 平台扣除</span>
              <div>
                <p style="color:orange;margin:5px 0"> 1.技师扣除 就是所有的分销金额都从技师金额里面扣 </p>
                <p> 技师所得金额 = 技师金额 - (技师一级佣金 + 技师二级佣金 + 用户一级佣金 + 用户二级佣金) </p>
                <p> 技师所得金额 : 258.23 = 301.81 - (15.57 + 6.22 + 15.57 + 6.22) </p>
                <p> 技师： 258.23 元、 商户： 66.67 元、 平台： 76.01 元、分销： 43.58 元</p>
              </div>
              <div>
                <p style="color:orange;margin:5px 0"> 2.平台扣除 就是所有的分销金额都从平台金额里面扣 </p>
                <p> 技师所得金额 = 301.81 元 </p>
                <p> 平台所得金额 = 平台金额 - (技师一级佣金 + 技师二级佣金 + 用户一级佣金 + 用户二级佣金) </p>
                <p> 平台所得金额: 32.43 = 76.01 - (15.57 + 6.22 + 15.57 + 6.22)</p>
                <p>技师： 301.81 元、 商户： 66.67 元、 平台所得： 32.43 元、 分销： 43.58 元 </p>
              </div>
            </div>
          </div>

        </el-col>
      </el-row>

    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import fareAPI from "@/api/fare.js";
export default {
  data() {
    return {
      obj: {}
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      let self = this;
      fareAPI
        .getorderData({}, true)
        .then(res => {
          self.obj = res.data;
          console.log(self.obj);

        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      fareAPI
        .postorderData(self.obj, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,

              type: "success"
            });
          }
          console.log(res);
        })
        .catch(err => {
          this.$message({
            message: err.msg,
            type: "warning"
          });
        });
    }
  }
};
</script>

<style scoped>
.col_item {
  margin: 10px 0;
}
.num_case {
  margin: 10px 0;
}
.co_case {
  color: red;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/order_proportion/index.vue